module.exports = __webpack_public_path__ + "d5cbfde9c07f60c2a3191eb55539d676.MP3";